export const FIELD_LIMITS = {
    DEFAULT_TEXT: 200,  // Used for Name, Title, Slug, Key
    DESCRIPTION: 500,   // Used for descriptions
    REFERENCE: 100,     // Used for Customer Reference Number
    EMAIL: 100,         // Used for Email addresses
    URL: 1024,          // Used for URL fields (e.g. logo URL)
    MIN_LENGTH: 3,      // Standard minimum length for text fields
    MAX_CUSTOMER_REFERENCE_LABEL_LENGTH: 50, // Max length for custom customer reference label
    SLUG_MAX_LENGTH: 50, // Max length for slug field
    USERNAME_MIN_LENGTH: 3, // Keep in sync with server USERNAME_MIN_LENGTH
    USERNAME_MAX_LENGTH: 50, // Keep in sync with server USERNAME_MAX_LENGTH
    EXTERNAL_ID: 255    // Used for external system IDs (account / sub-account / user)
};

// Usernames are stored as entered (unique case-insensitively) and never contain "@"
// (so login can tell them apart from emails). Keep in sync with server USERNAME_PATTERN.
export const USERNAME_REGEX = /^[A-Za-z0-9._-]+$/;

/** Returns an error message for an (optional) username, or null when valid/empty. */
export const validateUsername = (value) => {
    const username = (value || '').trim();
    if (!username) return null;
    if (username.length < FIELD_LIMITS.USERNAME_MIN_LENGTH || username.length > FIELD_LIMITS.USERNAME_MAX_LENGTH) {
        return `Username must be between ${FIELD_LIMITS.USERNAME_MIN_LENGTH} and ${FIELD_LIMITS.USERNAME_MAX_LENGTH} characters`;
    }
    if (!USERNAME_REGEX.test(username)) {
        return 'Username may contain only letters, numbers, ".", "_" and "-"';
    }
    return null;
};

export const DAISY_THEMES = [
  "light", "dark", "cupcake", "bumblebee", "emerald", "corporate", "synthwave",
  "retro", "cyberpunk", "valentine", "halloween", "garden", "forest", "aqua",
  "lofi", "pastel", "fantasy", "wireframe", "black", "luxury", "dracula",
  "cmyk", "autumn", "business", "acid", "lemonade", "night", "coffee",
  "winter", "dim", "nord", "sunset", "caramellatte", "abyss", "silk"
];